import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _18mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"18mp"}/>
}
